import { get } from "../api.js";

/**
 * Gets list of Contract Holders
 * @returns {Promise<ContractHolder[]>}
 */
export const getContractHoldersList = () => get("/sewppublic/contractholders/contractholderslist")
.then(({ data }) => data);

/**
 * Gets list of Contract Holders Groups
 * @param {boolean} [fedRamp=false]
 * @returns {Promise<ContractHolderGroup[]>}
 */
export const getContractHoldersGroups = (fedRamp = false) => {
  if (fedRamp) {
    return get("/sewppublic/contractholders/groups?page=FedRamp").then(({ data }) => data);
  } else {
    return get("/sewppublic/contractholders/groups").then(({ data }) => data);
  }
};

/**
 * Gets Contract Holder Details data
 * @param {number} contractHolderId
 * @returns {Promise<ContractHolderDetails>}
 */
export const getContractHolderDetails = (contractHolderId) => get(
  `/sewppublic/contractholders/contractholder/${contractHolderId}`).then(({ data }) => data);

/**
 * Gets list of Contract Holder Program Managers
 * @returns {Promise<ProgramManager[]>}
 */
export const getProgramManagers = () => get("/sewppublic/contractholders/programmanagerslist")
.then(({ data }) => data);

/**
 * Gets list of Small Business Contract Holders
 * @returns {Promise<SmallBusiness[]>}
 */
export const getSmallBusinesses = () => get("/sewppublic/contractholders/smallbusinesslist").then(({ data }) => data);

/**
 * Gets list of Business Breakdown group counts
 * @returns {Promise<GroupCount[]>}
 */
export const getGroupCounts = () => get("/sewppublic/contractholders/groupcounts").then(({ data }) => data);

/**
 * Gets list of Business Breakdown business size counts
 * @returns {Promise<BusinessSizeCount[]>}
 */
export const getBusinessSizeCounts = () => get("/sewppublic/contractholders/businesssizecounts")
.then(({ data }) => data);
